import React from "react";
import SideBarItem from "./components/SideBarItem";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";

function AdminLayout({ adminAccess }: any) {
  return (
    <div className="admin-layout">
      <input type="checkbox" style={{ display: "none" }} id="humberIcon" />
      <label className="mobile_open" htmlFor="humberIcon"></label>
      <div className="sidebar">
        <div className="sidebarlogo">image</div>
        <div className="sidenav_container">
          <ul>
            {adminAccess?.map((item: any, i: number) => (
              <SideBarItem key={i} item={item} />
            ))}
          </ul>
        </div>
      </div>
      <div className="main_container">
        <Navbar>
          <p>Admin</p>
          <NotificationsIcon />
          <div className="admin_menu">
            <AccountCircleIcon />
            <div className="dropdown">
              <div className="dropdown_content">
                <p
                  className="logout_text"
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/admin-login";
                  }}
                >
                  Logout
                </p>
              </div>
            </div>
          </div>
        </Navbar>
        <div className="container_main">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
